import { render, staticRenderFns } from "./order-pill.vue?vue&type=template&id=e639f610&scoped=true"
import script from "./order-pill.vue?vue&type=script&lang=js"
export * from "./order-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e639f610",
  null
  
)

export default component.exports